// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/build/css/" + "goals" + "." + "25e576a093d5cfe560b1" + ".css";
};